import React, { useEffect, useState } from 'react';
import { useApp } from '../context/AppContext';
import { BANNERS, PRODUCTS } from '../data/catalog';
import Icon from './Icon';
import './Hero.css';

const QUICK_PICKS = ['mycard-50', 'mycard-150', 'mycard-300', 'mycard-500', 'mycard-1000', 'mycard-3000', 'mycard-5000'];

export default function Hero() {
  const { navigate, fx, lang } = useApp();
  const [active, setActive] = useState(0);
  const rawBanner = BANNERS[active];
  const banner = {
    ...rawBanner,
    ...(rawBanner.i18n?.[lang] || rawBanner.i18n?.['zh-TW'] || {}),
  };
  const picks = QUICK_PICKS.map((id) => PRODUCTS.find((p) => p.id === id)).filter(Boolean);

  useEffect(() => {
    const id = setInterval(() => {
      setActive((a) => (a + 1) % BANNERS.length);
    }, 6500);
    return () => clearInterval(id);
  }, []);

  return (
    <section className="hero">
      <div className="container">
        <div className="hero__grid">
          {/* Main banner */}
          <div className="hero__main">
            <button
              type="button"
              className="hero__banner"
              onClick={() =>
                banner.productId
                  ? navigate('product', { id: banner.productId })
                  : navigate('vip')
              }
            >
              {BANNERS.map((b, i) => (
                <div
                  key={b.id}
                  className={`hero__banner-bg ${i === active ? 'is-on' : ''}`}
                  style={{ backgroundImage: `url(${b.image})` }}
                />
              ))}
              <div className="hero__banner-body">
                <span className="hero__banner-eyebrow">{banner.eyebrow}</span>
                <h2 className="hero__banner-title">{banner.title}</h2>
                {banner.sub && <p className="hero__banner-sub">{banner.sub}</p>}
                <span className="hero__banner-cta">
                  {banner.cta} <Icon name="arrowRight" size={14} />
                </span>
              </div>
            </button>

            {/* Thumbnail nav */}
            <ul className="hero__thumbs">
              {BANNERS.map((b, i) => (
                <li key={b.id}>
                  {(() => {
                    const tt = b.i18n?.[lang] || b.i18n?.['zh-TW'] || {};
                    return (
                      <button
                        type="button"
                        className={`hero__thumb ${i === active ? 'is-on' : ''}`}
                        onClick={() => setActive(i)}
                        aria-label={tt.title}
                      >
                        <span
                          className="hero__thumb-img"
                          style={{ backgroundImage: `url(${b.image})` }}
                        />
                        <span className="hero__thumb-meta">
                          <em>{tt.eyebrow}</em>
                          <strong>{tt.title}</strong>
                        </span>
                      </button>
                    );
                  })()}
                </li>
              ))}
            </ul>
          </div>

          {/* Quick picks sidebar */}
          <aside className="hero__quick">
            <header className="hero__quick-head">
              <h3>常用儲值</h3>
              <button
                className="hero__quick-more"
                onClick={() => navigate('category', { id: 'all' })}
              >
                全部 <Icon name="arrowRight" size={11} />
              </button>
            </header>
            <ul className="hero__quick-list">
              {picks.map((p) => (
                <li key={p.id}>
                  <button
                    className="hero__quick-item"
                    onClick={() => navigate('product', { id: p.id })}
                  >
                    <span
                      className="hero__quick-art"
                      style={{ backgroundImage: `url(${p.image})` }}
                      aria-hidden
                    />
                    <span className="hero__quick-info">
                      <span className="hero__quick-name">{p.name}</span>
                      <span className="hero__quick-price">
                        {fx(p.denominations[0].price)}
                      </span>
                    </span>
                  </button>
                </li>
              ))}
            </ul>
          </aside>
        </div>
      </div>
    </section>
  );
}
